<template>
  <v-breadcrumbs :items="breadcrumbItems" v-if="!hideBreadcrumbs" :class="{ 'dark-mode': isDarkMode }">
    <template v-slot:divider>
      <div class="divider-img">
        <v-img src="../../../assets/Images/breadcrumb-right-con.png" width="6" height="11"></v-img>
      </div>
    </template>
    <template v-slot:prepend>
      <div class="home-img">
        <v-img src="../../../assets/Images/House.png" class="cursor-pointer" width="20" height="20"
          @click="goToAssets"></v-img>
      </div>
      <div class="divider-img" v-if="isAssetsRoute">
        <v-img src="../../../assets/Images/breadcrumb-right-con.png" width="6" height="11"></v-img>
      </div>
    </template>
    <template v-slot:item="{ item, index }">
      <div class="text-capitalize test-text d-flex align-end"
        v-if="index === breadcrumbItems.length - 1 && !showTestsDropdown && item.isTestType">
        {{ item.title }}
        <v-icon width="16" height="16" @click="toggleTestsDropdown">mdi-chevron-down</v-icon>
      </div>
      <div class="text-capitalize test-text" v-else-if="showTestsDropdown && item.isTestType" ref="dropdownMenu">
        {{ item.title }}
        <v-icon width="16" height="16" @click="toggleTestsDropdown">mdi-chevron-up</v-icon>
        <div class="dropdown-menu">
          <div class="test-name-div" v-if="isTestAvailable">
            <div class="breadcrumb-test-name" @click="openSampleValidationPage">
              Sample Validation
            </div>
          </div>
          <div class="test-name-div" v-for="(test, index) in allTests" :key="`test-${index}-${test?.ID || test?.id || index}`">
            <div class="breadcrumb-test-name" @click="openTestPage(test, index)"
              :class="{ 'active': activeTestIndex === index }">
              <template v-if="getTestType(test) === 'compositiontests'">
                <template v-if="test.contaminationType || test.recombinationType">
                  {{ getTestDisplayName(getTestType(test), test.index || 0) }}({{ test.contaminationType ? test.contaminationType.charAt(0).toUpperCase() + test.contaminationType.slice(1) : '' }}{{ test.recombinationType ? ' ' + test.recombinationType.charAt(0).toUpperCase() + test.recombinationType.slice(1) : '' }})
                </template>
                <template v-else>{{ getTestDisplayName(getTestType(test), test.index || 0) }}</template>
              </template>
              <template v-else>
                {{ getTestDisplayName(getTestType(test), test.index || 0)}}
                <template v-if="test.testTemperature || test.testTemperature_UOM">
                  ({{ test.testTemperature }} {{ test.testTemperature_UOM }})
                </template>
              </template>
            </div>
          </div>
        </div>
      </div>
      <div class="text-capitalize" v-else @click.native="item.title === 'Exploratory Data Analysis (EDA)' ? null : handleBreadcrumb(item.title)">
        <router-link v-if="item.title !== 'Exploratory Data Analysis (EDA)'" :to="{ path: item.href }">
          {{ item.title }}
        </router-link>
        <span v-else>
          {{ item.title }}
        </span>
      </div>
    </template>
    <v-snackbar v-model="snackbar.visible" :color="snackbar.color" :timeout="snackbar.timeout">
      {{ snackbar.message }}
    </v-snackbar>
  </v-breadcrumbs>
</template>

<script>
import axios from "axios";
import { mapActions, mapGetters } from 'vuex';
export default {
  name: "Links",
  data: () => ({
    items: [],
    currentURLSegments: [],
    showTestsDropdown: false,
    tenantId: localStorage.getItem("tenantId"),
    allTests: [],
    isTestAvailable: false,
    currentSampleId: localStorage.getItem("sampleId"),
    isLoadingTests: false,
    snackbar: {
      visible: false,
      message: "",
      color: "success",
      timeout: 3000,
    },
  }),
  computed: {
    ...mapGetters("test", ['activeTestIndex']),
    ...mapGetters("darkMode", ["isDarkMode"]),
    isAssetsRoute() {
      return this.$route.name !== 'Assets' && this.$route.name !== 'DataManagement' && this.$route.name !== 'FluidsDataStudio' && this.$route.name !== 'Main';
    },
    hideBreadcrumbs() {
      const pathSegments = this.$route.path.split('/').filter(Boolean);
      if (pathSegments.length < 2) return false;

      const routePath = `/${pathSegments.slice(1).join('/')}`.toLowerCase();

      return routePath.includes('/dashboards') ||
        routePath.includes('/fluidsdata-studio') ||
        routePath.includes('/roles') ||
        routePath.includes('/users') ||
        routePath.includes('/fluidsintelligence') ||
        routePath.includes('/pvt-prediction') ||
        routePath.includes('/agentic-dashboard');
    },

    breadcrumbItems() {
      const itemsCopy = this.items.slice();
      const pathSegments = this.$route.path.split('/').filter(Boolean);
      if (pathSegments.length < 2) return [];

      const tenantId = pathSegments[0];
      const filteredSegments = pathSegments.slice(1);

      const assetParam = this.$route.params.asset;
      const fieldParam = this.$route.params.field;
      const wellParam = this.$route.params.well;
      const currentRoute = `/${filteredSegments.join('/')}`;

      if (currentRoute.includes("/qaqc")) {
        const testType = this.$route.params.testType;
        const testId = this.$route.params.testId;
        const sampleId = this.currentSampleId || localStorage.getItem("sampleId");

        itemsCopy.push({
          title: "QA/QC",
          href: `/${tenantId}/qaqc`
        });

        if (currentRoute.includes("/qaqc/overview")) {
          itemsCopy.push({
            title: "Overview",
            href: `/${tenantId}/qaqc/overview`
          });
        } else if (currentRoute.includes("/qaqc/detail")) {
          itemsCopy.push({
            title: "Sample Details",
            href: `/${tenantId}/qaqc/detail`
          });
          if (sampleId) {
            itemsCopy.push({
              title: "Tests",
              href: `/${tenantId}/qaqc/detail`
            });
          }
        } else if (testType) {
          let testDisplayTitle = testType.charAt(0).toUpperCase() + testType.slice(1);
          
          if (testId && this.allTests && this.allTests.length > 0) {
            const currentTest = this.allTests.find(test => {
              const testTestType = test.testType || test.TestType || test.test_type;
              const normalizedRouteTestType = testType.toLowerCase().replace(/test$/, 'tests');
              const testTypeMatch = testTestType === testType || testTestType === normalizedRouteTestType || testTestType === testType.replace(/s$/, '');
              const idMatch = (test.ID || test.id || test.testId) === testId || (test.ID || test.id || test.testId) === String(testId);
              return testTypeMatch && idMatch;
            });
            
            if (currentTest) {
              if (this.getTestType(currentTest) === 'compositiontests') {
                if (currentTest.contaminationType || currentTest.recombinationType) {
                  testDisplayTitle = `${this.getTestDisplayName(this.getTestType(currentTest), currentTest.index || 0)}(${currentTest.contaminationType ? currentTest.contaminationType.charAt(0).toUpperCase() + currentTest.contaminationType.slice(1) : ''}${currentTest.recombinationType ? ' ' + currentTest.recombinationType.charAt(0).toUpperCase() + currentTest.recombinationType.slice(1) : ''})`;
                } else {
                  testDisplayTitle = this.getTestDisplayName(this.getTestType(currentTest), currentTest.index || 0);
                }
              } else {
                testDisplayTitle = this.getTestDisplayName(this.getTestType(currentTest), currentTest.index || 0);
                if (currentTest.testTemperature || currentTest.testTemperature_UOM) {
                  testDisplayTitle += ` (${currentTest.testTemperature} ${currentTest.testTemperature_UOM || ''})`.trim();
                }
              }
            }
          }
          
          itemsCopy.push(
            {
              title: "Sample Details",
              href: `/${tenantId}/qaqc/detail`
            },
            {
              title: testDisplayTitle,
              href: testId ? `/${tenantId}/qaqc/test/${testType}/${testId}` : `/${tenantId}/qaqc/test/${testType}`,
              isTestType: true
            }
          );
        }
      }
      else if (
        currentRoute.includes("/compositiontests") ||
        currentRoute.includes("/dltest") ||
        currentRoute.includes("/ccetest") ||
        currentRoute.includes("/cvdtest") ||
        currentRoute.includes("/separatortest") ||
        currentRoute.includes("/viscositytest") ||
        currentRoute.includes("/samplevalidation") ||
        currentRoute.includes("/sampleinformation")
        ) {
          const assetsTestMatch = currentRoute.match(/\/(compositiontests|dltest|ccetest|cvdtest|separatortest|viscositytest)\/([^/]+)$/);
          const routeTestSegment = assetsTestMatch ? assetsTestMatch[1] : null;
          const routeTestId = assetsTestMatch ? assetsTestMatch[2] : null;
          const sampleIdParam = this.$route.params.sampleId;
          const samplesPageHref = `/${tenantId}/assets/${assetParam || ''}/${fieldParam || ''}/${wellParam || ''}`;

          itemsCopy.push(
            {
              title: assetParam ? `Asset: ${assetParam.replace(/\//g, '-').replace(/ /g, '-')}` : "Assets",
              href: `/${tenantId}/assets/${assetParam || ''}`
            },
            {
              title: fieldParam ? `Field: ${fieldParam.replace(/\//g, '-').replace(/ /g, '-')}` : "Fields",
              href: `/${tenantId}/assets/${assetParam || ''}/${fieldParam || ''}`
            },
            {
              title: wellParam ? `Well: ${wellParam.replace(/\//g, '-').replace(/ /g, '-')}` : "Wells",
              href: `/${tenantId}/assets/${assetParam || ''}/${fieldParam || ''}/${wellParam || ''}`
            },
            {
              title: "Samples",
              href: samplesPageHref
            }
          );

          if (routeTestSegment && routeTestId) {
            const normalizedTestType = routeTestSegment === 'compositiontests' ? 'compositiontests' : routeTestSegment + 's';
            let testDisplayTitle = this.displayTestType(normalizedTestType);
            if (this.allTests && this.allTests.length > 0) {
              const currentTest = this.allTests.find(test => {
                const testTestType = test.testType || test.TestType || test.test_type;
                const testTypeMatch = testTestType === normalizedTestType || testTestType === routeTestSegment;
                const idMatch = (test.ID || test.id || test.testId) === routeTestId || (test.ID || test.id || test.testId) === String(routeTestId);
                return testTypeMatch && idMatch;
              });
              if (currentTest) {
                if (this.getTestType(currentTest) === 'compositiontests') {
                  if (currentTest.contaminationType || currentTest.recombinationType) {
                    testDisplayTitle = `${this.getTestDisplayName(this.getTestType(currentTest), currentTest.index || 0)}(${currentTest.contaminationType ? currentTest.contaminationType.charAt(0).toUpperCase() + currentTest.contaminationType.slice(1) : ''}${currentTest.recombinationType ? ' ' + currentTest.recombinationType.charAt(0).toUpperCase() + currentTest.recombinationType.slice(1) : ''})`;
                  } else {
                    testDisplayTitle = this.getTestDisplayName(this.getTestType(currentTest), currentTest.index || 0);
                  }
                } else {
                  testDisplayTitle = this.getTestDisplayName(this.getTestType(currentTest), currentTest.index || 0);
                  if (currentTest.testTemperature || currentTest.testTemperature_UOM) {
                    testDisplayTitle += ` (${currentTest.testTemperature} ${currentTest.testTemperature_UOM || ''})`.trim();
                  }
                }
              }
            }
            const currentTestHref = sampleIdParam
              ? `/${tenantId}/assets/${assetParam || ''}/${fieldParam || ''}/${wellParam || ''}/${sampleIdParam}/${routeTestSegment}/${routeTestId}`
              : `/${tenantId}/assets/${assetParam || ''}/${fieldParam || ''}/${wellParam || ''}/${routeTestSegment}/${routeTestId}`;
            itemsCopy.push({
              title: testDisplayTitle,
              href: currentTestHref,
              isTestType: true
            });
          } else {
            itemsCopy.push({
              title: "Tests",
              href: samplesPageHref
            });
          }
        } else if (wellParam) {
          itemsCopy.push(
            { title: `Asset: ${assetParam || "Assets"}`, href: `/${tenantId}/assets/${assetParam || ''}` },
            { title: `Field: ${fieldParam}`, href: `/${tenantId}/assets/${assetParam || ''}/${fieldParam || ''}` },
            { title: `Well: ${wellParam}`, href: `/${tenantId}/assets/${assetParam || ''}/${fieldParam || ''}/${wellParam || ''}` }
          );
        } else if (fieldParam) {
          itemsCopy.push(
            { title: `Asset: ${assetParam || "Assets"}`, href: `/${tenantId}/assets/${assetParam || ''}` },
            { title: `Field: ${fieldParam}`, href: `/${tenantId}/assets/${assetParam || ''}/${fieldParam || ''}` }
          );
        } else if (assetParam) {
          itemsCopy.push(
            { title: `Asset: ${assetParam || "Assets"}`, href: `/${tenantId}/assets/${assetParam || ''}` }
          );
        } else {
          let currentPath = `/${tenantId}`;
          itemsCopy.push(
            ...filteredSegments
              .filter(segment => !["assets", "data-management", "dashboards", "fluidsdata-studio"].includes(segment.toLowerCase())) 
              .map(segment => {
                currentPath += `/${segment.replace(/\//g, '-').replace(/ /g, '-')}`;
                let title = segment.replace(/-/g, ' ').charAt(0).toUpperCase() + segment.replace(/-/g, ' ').slice(1);

                if(title === "Exploratory Data Analysis" || title === "Exploratory-data-analysis")
                {
                  title = "Exploratory Data Analysis (EDA)";
                }
                else if(currentRoute.includes("/exploratory-data-analysis/inventory-analysis") && title !== "Exploratory-data-analysis") 
                {
                  title = "Inventory Analysis";
                }
                else if(currentRoute.includes("/exploratory-data-analysis/twodhistogram-kde"))
                {
                  title = "2D Histogram and Bivariate KDE";
                }
                else if(currentRoute.includes("/exploratory-data-analysis/correlation-analysis"))
                {
                  title = "Correlation Analysis";
                }
                else if(currentRoute.includes("/exploratory-data-analysis/statistical-analysis"))
                {
                  title = "Statistical Analysis";
                }
                else if(currentRoute.includes("/exploratory-data-analysis/3d-plot-analysis"))
                {
                  title = "3D Plot Analysis";
                }
                else if(currentRoute.includes("/exploratory-data-analysis/bubble-plot-analysis"))
                {
                  title = "Bubble Plot Analysis";
                }
                else if(currentRoute.includes("/exploratory-data-analysis/heatmap-analysis"))
                {
                  title = "Heatmap Analysis";
                }
                else if(currentRoute.includes("/exploratory-data-analysis/composition-gradient-analysis"))
                {
                  title = "Composition Gradient Analysis";
                }
                else if(title === "Qaqc" || title === "qaqc" || title === "QA QC")
                {
                  title = "QA/QC";
                }
                else if(currentRoute.includes("/qaqc/data-validation") && title !== "QA/QC") 
                {
                  title = "Data Validation";
                }
                else if(currentRoute.includes("/qaqc/quality-metrics") && title !== "QA/QC")
                {
                  title = "Quality Metrics";
                }
                else if(currentRoute.includes("/qaqc/compliance-check") && title !== "QA/QC")
                {
                  title = "Compliance Check";
                }
                else if(currentRoute.includes("/qaqc/qaqc-wells") && title !== "QA/QC")
                {
                  title = "Wells Overview";
                }
                else if(currentRoute.includes("/qaqc/detail") && title !== "QA/QC")
                {
                  title = "Detail";
                }
                
                return {
                  title,
                  href: currentPath,
                  icon: "mdi-chevron-down"
                };
              })
          );
        }
        return itemsCopy;
    },
    displayTestType() {
      return function (testType) {
        switch (testType) {
          case 'compositiontests':
            return 'Composition';
          case 'dltests':
          case 'dltest':
            return 'DL Test';
          case 'ccetests':
          case 'ccetest':
            return 'CCE Test';
          case 'cvdtests':
          case 'cvdtest':
            return 'CVD Test';
          case 'separatortests':
          case 'separatortest':
            return 'Separator Test';
          case 'viscositytests':
          case 'viscositytest':
            return 'Viscosity Test';
          default:
            return testType;
        }
      }
    },
  },
  methods: {
    ...mapActions("test", ['setActiveTestIndex']),
    showSnackbar(message, color = "success") {
      this.snackbar.message = message;
      this.snackbar.color = color;
      this.snackbar.visible = true;
    },
         goToAssets() {
       const lastView = localStorage.getItem("activeMenu");
       const urlSegments = window.location.pathname.split("/").filter(Boolean);
       const tenantId = urlSegments.length > 0 ? urlSegments[0] : localStorage.getItem("tenantId");

       if (!tenantId) {
         return;
       }

       if (lastView && lastView.toLowerCase() === "data management") {
         this.$router.push(`/${tenantId}/data-management`);
       }
       else if (lastView && lastView.toLowerCase() === "qa/qc") {
         this.$router.push(`/${tenantId}/qaqc`);
       }
       else if (lastView && lastView === "QA/QC Overview") {
         this.$router.push(`/${tenantId}/qaqc/overview`);
       }
       else if (urlSegments[1] && urlSegments[1].toLowerCase() === "assets") {
         this.$router.push(`/${tenantId}/assets`);
       }
     },
    updateBreadcrumbs() {
      const currentURL = window.location.pathname;
      this.currentURLSegments = currentURL
        .split("/")
        .filter((segment) => segment !== "");
      let updatedPath = `/${this.currentURLSegments.join("/")}`;
      updatedPath = updatedPath.replace(/\/$/, "");
      window.history.replaceState({}, "", updatedPath);
    },
    toggleTestsDropdown(event) {
      event.stopPropagation();
      this.showTestsDropdown = !this.showTestsDropdown;
      
      if (this.showTestsDropdown) {
        if (!this.allTests || this.allTests.length === 0) {
          this.showTests();
        }
      }
    },
    showTests() {
      const pathSegments = this.$route.path.split('/').filter(Boolean);
      const tenantId = pathSegments[0] || '';
      const currentRoute = `/${pathSegments.slice(1).join('/')}`;
      const isAssetsTestRoute = currentRoute.includes("/assets/") && (
        currentRoute.includes("/dltest") || currentRoute.includes("/ccetest") ||
        currentRoute.includes("/cvdtest") || currentRoute.includes("/separatortest") ||
        currentRoute.includes("/viscositytest") || currentRoute.includes("/compositiontests")
      );
      const sampleId = isAssetsTestRoute
        ? (this.$route.params.sampleId || localStorage.getItem("sampleId"))
        : (this.currentSampleId || localStorage.getItem("sampleId"));

      if (!sampleId) {
        return;
      }
      if (this.isLoadingTests) {
        return;
      }

      this.isTestAvailable = false;
      this.isLoadingTests = true;

      axios
        .get(process.env.VUE_APP_API_URL + `public/api/samples/${sampleId}/tests`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
            "X-TenantID": tenantId,
          },
        })
        .then((response) => {
          if (response && response.data && (response.data.statusCode === 200 || response.data.statusCode === 201)) {
            let tests = [];
            const data = response.data.data;
            
            if (data) {
              this.isTestAvailable = data.IsTestAvailable === true || data.isTestAvailable === true;
              if (Array.isArray(data.compositiontests) && data.compositiontests.length > 0) {
                data.compositiontests.forEach((test, idx) => {
                  tests.push({
                    ...test,
                    testType: 'compositiontests',
                    TestType: 'compositiontests',
                    test_type: 'compositiontests',
                    ID: test.ID || test.id || test._id,
                    id: test.ID || test.id || test._id,
                    index: idx
                  });
                });
              }
              if (Array.isArray(data.ccetests) && data.ccetests.length > 0) {
                data.ccetests.forEach((test, idx) => {
                  tests.push({
                    ...test,
                    testType: 'ccetests',
                    TestType: 'ccetests',
                    test_type: 'ccetests',
                    ID: test.ID || test.id || test._id,
                    id: test.ID || test.id || test._id,
                    index: idx
                  });
                });
              }
              if (Array.isArray(data.dltests) && data.dltests.length > 0) {
                data.dltests.forEach((test, idx) => {
                  tests.push({
                    ...test,
                    testType: 'dltests',
                    TestType: 'dltests',
                    test_type: 'dltests',
                    ID: test.ID || test.id || test._id,
                    id: test.ID || test.id || test._id,
                    index: idx
                  });
                });
              }
              if (Array.isArray(data.cvdtests) && data.cvdtests.length > 0) {
                data.cvdtests.forEach((test, idx) => {
                  tests.push({
                    ...test,
                    testType: 'cvdtests',
                    TestType: 'cvdtests',
                    test_type: 'cvdtests',
                    ID: test.ID || test.id || test._id,
                    id: test.ID || test.id || test._id,
                    index: idx
                  });
                });
              }
              if (Array.isArray(data.viscositytests) && data.viscositytests.length > 0) {
                data.viscositytests.forEach((test, idx) => {
                  tests.push({
                    ...test,
                    testType: 'viscositytests',
                    TestType: 'viscositytests',
                    test_type: 'viscositytests',
                    ID: test.ID || test.id || test._id,
                    id: test.ID || test.id || test._id,
                    index: idx
                  });
                });
              }
              if (Array.isArray(data.separatortests) && data.separatortests.length > 0) {
                data.separatortests.forEach((test, idx) => {
                  tests.push({
                    ...test,
                    testType: 'separatortests',
                    TestType: 'separatortests',
                    test_type: 'separatortests',
                    ID: test.ID || test.id || test._id,
                    id: test.ID || test.id || test._id,
                    index: idx
                  });
                });
              }
            }
            
            if (tests.length === 0 && Array.isArray(data.allTests) && data.allTests.length > 0) {
              const firstItem = data.allTests[0];
              const isEmpty = !firstItem || Object.keys(firstItem).length === 0;
              
              if (isEmpty) {
                axios
                  .get(process.env.VUE_APP_API_URL + `public/api/samples/${sampleId}`, {
                    headers: {
                      Authorization: `Bearer ${localStorage.getItem("authToken")}`,
                      "X-TenantID": tenantId,
                    },
                  })
                  .then((sampleResponse) => {
                    if (sampleResponse && sampleResponse.data && 
                        (sampleResponse.data.statusCode === 200 || sampleResponse.data.statusCode === 201)) {
                      const sampleData = sampleResponse.data.data;
                      
                      if (sampleData) {
                        const actualSampleData = sampleData.sample || sampleData;
                        this.isTestAvailable = actualSampleData.IsTestAvailable === true || actualSampleData.isTestAvailable === true;
                        this.processSampleDataForTests(actualSampleData, sampleId);
                        return;
                      }
                    }
                  })
                  .catch((error) => {
                  });
                return;
              } else {
                tests = data.allTests.map((test, idx) => {
                  const testId = test.ID || test.id || test._id || test.testId;
                  return {
                    ...test,
                    testType: test.testType || test.TestType || test.test_type || 'unknown',
                    TestType: test.TestType || test.testType || test.test_type || 'unknown',
                    test_type: test.test_type || test.testType || test.TestType || 'unknown',
                    ID: testId,
                    id: testId,
                    testId: testId,
                    index: test.index !== undefined ? test.index : idx
                  };
                });
              }
            }
            
            if (tests.length > 0) {
              const validTests = tests.filter(test => {
                if (!test) return false;
                const isSampleValidation = (test.testType === 'sampleValidation' || 
                                           test.TestType === 'sampleValidation' || 
                                           test.test_type === 'sampleValidation' ||
                                           test.type === 'Sample Validation');
                return !isSampleValidation;
              });

              const testGroups = {};
              validTests.forEach(test => {
                let testType = test.testType || test.TestType || test.test_type;
                
                if (!testType) {
                  if (test.compositiontests || test.type === 'Composition') {
                    testType = 'compositiontests';
                  } else if (test.ccetests || test.type === 'CCE Test') {
                    testType = 'ccetests';
                  } else if (test.dltests || test.type === 'DL Test') {
                    testType = 'dltests';
                  } else if (test.cvdtests || test.type === 'CVD Test') {
                    testType = 'cvdtests';
                  } else if (test.viscositytests || test.type === 'Viscosity Test') {
                    testType = 'viscositytests';
                  } else if (test.separatortests || test.type === 'Separator Test') {
                    testType = 'separatortests';
                  } else if (test.type === 'Sample Validation') {
                    testType = 'sampleValidation';
                  } else {
                    testType = 'unknown';
                  }
                  
                  test.testType = testType;
                  test.TestType = testType;
                  test.test_type = testType;
                }
                
                if (!testGroups[testType]) {
                  testGroups[testType] = [];
                }
                testGroups[testType].push(test);
              });

              Object.keys(testGroups).forEach(testType => {
                const group = testGroups[testType];
                if (group.length > 1) {
                  group.forEach((test, index) => {
                    test.index = index + 1;
                  });
                }
              });

              const finalTestsFromMain = [].concat(...Object.values(testGroups));
              this.allTests.splice(0, this.allTests.length, ...finalTestsFromMain);
              this.$nextTick(() => {
                this.$forceUpdate();
              });
            } else {
              this.isTestAvailable = false;
            }
          }
          else if (response && response.data && response.data.message) {
            this.showSnackbar(response.data.message, "error");
          }
          else {
            this.showSnackbar("Error in fetching tests", "error");
          }
        })
        .catch((error) => {
          if (error.response) {
          }
        })
        .finally(() => {
          this.isLoadingTests = false;
        });
    },

    processSampleDataForTests(sampleData, sampleId) {
      let tests = [];
      
      if (Array.isArray(sampleData.compositiontests) && sampleData.compositiontests.length > 0) {
        sampleData.compositiontests.forEach((test, index) => {
          const testId = test.ID || test._id || test.id;
          tests.push({
            type: 'Composition',
            testType: 'compositiontests',
            TestType: 'compositiontests',
            test_type: 'compositiontests',
            testId: testId,
            ID: testId,
            id: testId,
            testData: test,
            index: index,
            contaminationType: test.contaminationType,
            recombinationType: test.recombinationType,
            testTemperature: test.testTemperature,
            testTemperature_UOM: test.testTemperature_UOM
          });
        });
      }
      
      if (Array.isArray(sampleData.ccetests) && sampleData.ccetests.length > 0) {
        sampleData.ccetests.forEach((test, index) => {
          const testId = test.ID || test._id || test.id;
          tests.push({
            type: 'CCE Test',
            testType: 'ccetests',
            TestType: 'ccetests',
            test_type: 'ccetests',
            testId: testId,
            ID: testId,
            id: testId,
            testData: test,
            index: index,
            testTemperature: test.testTemperature,
            testTemperature_UOM: test.testTemperature_UOM
          });
        });
      }
      
      if (Array.isArray(sampleData.dltests) && sampleData.dltests.length > 0) {
        sampleData.dltests.forEach((test, index) => {
          const testId = test.ID || test._id || test.id;
          tests.push({
            type: 'DL Test',
            testType: 'dltests',
            TestType: 'dltests',
            test_type: 'dltests',
            testId: testId,
            ID: testId,
            id: testId,
            testData: test,
            index: index,
            testTemperature: test.testTemperature,
            testTemperature_UOM: test.testTemperature_UOM
          });
        });
      }
      
      if (Array.isArray(sampleData.cvdtests) && sampleData.cvdtests.length > 0) {
        sampleData.cvdtests.forEach((test, index) => {
          const testId = test.ID || test._id || test.id;
          tests.push({
            type: 'CVD Test',
            testType: 'cvdtests',
            TestType: 'cvdtests',
            test_type: 'cvdtests',
            testId: testId,
            ID: testId,
            id: testId,
            testData: test,
            index: index,
            testTemperature: test.testTemperature,
            testTemperature_UOM: test.testTemperature_UOM
          });
        });
      }
      
      if (Array.isArray(sampleData.viscositytests) && sampleData.viscositytests.length > 0) {
        sampleData.viscositytests.forEach((test, index) => {
          const testId = test.ID || test._id || test.id;
          tests.push({
            type: 'Viscosity Test',
            testType: 'viscositytests',
            TestType: 'viscositytests',
            test_type: 'viscositytests',
            testId: testId,
            ID: testId,
            id: testId,
            testData: test,
            index: index,
            testTemperature: test.testTemperature,
            testTemperature_UOM: test.testTemperature_UOM
          });
        });
      }
      
      if (Array.isArray(sampleData.separatortests) && sampleData.separatortests.length > 0) {
        sampleData.separatortests.forEach((test, index) => {
          const testId = test.ID || test._id || test.id;
          tests.push({
            type: 'Separator Test',
            testType: 'separatortests',
            TestType: 'separatortests',
            test_type: 'separatortests',
            testId: testId,
            ID: testId,
            id: testId,
            testData: test,
            index: index,
            testTemperature: test.testTemperature,
            testTemperature_UOM: test.testTemperature_UOM
          });
        });
      }
      
      const validTests = tests.filter(test => {
        if (!test) return false;
        const isSampleValidation = (test.testType === 'sampleValidation' || 
                                   test.TestType === 'sampleValidation' || 
                                   test.test_type === 'sampleValidation' ||
                                   test.type === 'Sample Validation');
        return !isSampleValidation;
      });
      
      const testGroups = {};
      validTests.forEach(test => {
        const testType = test.testType || test.TestType || test.test_type || 'unknown';
        if (!testGroups[testType]) {
          testGroups[testType] = [];
        }
        testGroups[testType].push(test);
      });
      
      Object.keys(testGroups).forEach(testType => {
        const group = testGroups[testType];
        group.forEach((test, index) => {
          if (group.length > 1) {
            test.index = index + 1;
          } else {
            test.index = test.index !== undefined ? test.index : 0;
          }
        });
      });

      const finalTests = [].concat(...Object.values(testGroups));
      this.allTests.splice(0, this.allTests.length, ...finalTests);
      this.$nextTick(() => {
        this.$forceUpdate();
      });
    },

    getTestType(test) {
      return test?.testType || test?.TestType || test?.test_type || 'unknown';
    },
    getTestDisplayName(testType, index) {
      if (!testType || testType === 'unknown') {
        return 'Unknown Test';
      }
      const testTypeDisplay = this.displayTestType(testType);
      return index ? `${testTypeDisplay} (Test #${index})` : testTypeDisplay;
    },

    openTestPage(test, index) {
      this.setActiveTestIndex(index);
      this.showTestsDropdown = false;

      const sampleId = localStorage.getItem("sampleId");
      const testId = test.ID || test.id;
      localStorage.setItem("sampleId", sampleId);
      localStorage.setItem("testId", testId);
      const testType = this.getTestType(test);

      const pathSegments = this.$route.path.split('/').filter(Boolean);
      const tenantId = pathSegments[0] || '';
      const currentRoute = `/${pathSegments.slice(1).join('/')}`;
      
      if (currentRoute.includes("/qaqc")) {
        let newRoute = `/${tenantId}/qaqc/test/${testType}/${testId}`;
        localStorage.setItem("lastView", newRoute);
        this.$router.push(newRoute);
      } else {
        const routeParams = { ...this.$route.params };
        let newRoute = `/${tenantId}/assets/${routeParams.asset ? routeParams.asset.replace(/\//g, '-').replace(/ /g, '-') : ''}/${routeParams.field ? routeParams.field.replace(/\//g, '-').replace(/ /g, '-') : ''}/${routeParams.well ? routeParams.well.replace(/\//g, '-').replace(/ /g, '-') : ''}/${testType ? testType.replace(/\//g, '-').replace(/ /g, '-') : ''}/${testId ? testId.replace(/\//g, '-').replace(/ /g, '-') : ''}`;
        localStorage.setItem("lastView", newRoute);
        this.$router.push(newRoute);
      }
    },

    openSampleValidationPage() {
      this.showTestsDropdown = false;

      const sampleId = localStorage.getItem("sampleId");
      localStorage.setItem("sampleId", sampleId);

      const pathSegments = this.$route.path.split('/').filter(Boolean);
      const tenantId = pathSegments[0] || '';
      const currentRoute = `/${pathSegments.slice(1).join('/')}`;
      
      if (currentRoute.includes("/qaqc")) {
        let newRoute = `/${tenantId}/qaqc/detail`;
        localStorage.setItem("lastView", newRoute);
        this.$router.push(newRoute);
      } else {
        const routeParams = { ...this.$route.params };
        let newRoute = `/${tenantId}/assets/${routeParams.asset ? routeParams.asset.replace(/\//g, '-').replace(/ /g, '-') : ''}/${routeParams.field ? routeParams.field.replace(/\//g, '-').replace(/ /g, '-') : ''}/${routeParams.well ? routeParams.well.replace(/\//g, '-').replace(/ /g, '-') : ''}/samplevalidation/${sampleId}`;
        localStorage.setItem("lastView", newRoute);
        this.$router.push(newRoute);
      }
    },
    closeDropdownMenuOnClickOutside(event) {
      if (this.showTestsDropdown) {
        if (this.$refs.dropdownMenu && !this.$refs.dropdownMenu.contains(event.target)) {
          this.showTestsDropdown = false;
        }
      }
    },
    handleBreadcrumb(title) {
      if (title === "Dashboards") {
        localStorage.removeItem("lastVisitedDashboard");
      } 
    },
    handleStorageChange(event) {
      if (event.key === "sampleId") {
        this.currentSampleId = event.newValue;
        this.allTests = [];
        this.$forceUpdate();
      }
    },
    handleSampleIdChange() {
      this.currentSampleId = localStorage.getItem("sampleId");
      this.allTests = []; // Clear so breadcrumb watcher fetches tests for new sample
      this.$forceUpdate();
    }
  },
    watch: {
    $route(to, from) {
      this.updateBreadcrumbs();
      const newSampleId = localStorage.getItem("sampleId");
      if (this.currentSampleId !== newSampleId) {
        this.currentSampleId = newSampleId;
        this.allTests = [];
      }
    },
    breadcrumbItems: {
      handler(newItems, oldItems) {
        const containsTestType = newItems.some(item => item.isTestType === true);
        if (containsTestType && (!this.allTests || this.allTests.length === 0)) {
          this.showTests();
        }
      },
      deep: true,
      immediate: true
    },
  },
  mounted() {
    document.body.addEventListener("click", this.closeDropdownMenuOnClickOutside);
    this.updateBreadcrumbs();
    window.addEventListener("storage", this.handleStorageChange);
    window.addEventListener("sampleIdChanged", this.handleSampleIdChange);
  },
  beforeUnmount() {
    document.body.removeEventListener("click", this.closeDropdownMenuOnClickOutside);
    window.removeEventListener("storage", this.handleStorageChange);
    window.removeEventListener("sampleIdChanged", this.handleSampleIdChange);
  },
};
</script>